/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UploadPlatformImageSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UploadPlatformImageRequest = {
  contentLength: number;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type UploadPlatformImageSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UploadPlatformImageSecurity$outboundSchema: z.ZodMiniType<
  UploadPlatformImageSecurity$Outbound,
  UploadPlatformImageSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function uploadPlatformImageSecurityToJSON(
  uploadPlatformImageSecurity: UploadPlatformImageSecurity,
): string {
  return JSON.stringify(
    UploadPlatformImageSecurity$outboundSchema.parse(
      uploadPlatformImageSecurity,
    ),
  );
}

/** @internal */
export type UploadPlatformImageRequest$Outbound = {
  "Content-Length": number;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const UploadPlatformImageRequest$outboundSchema: z.ZodMiniType<
  UploadPlatformImageRequest$Outbound,
  UploadPlatformImageRequest
> = z.pipe(
  z.object({
    contentLength: z.int(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      contentLength: "Content-Length",
      gramSession: "Gram-Session",
    });
  }),
);

export function uploadPlatformImageRequestToJSON(
  uploadPlatformImageRequest: UploadPlatformImageRequest,
): string {
  return JSON.stringify(
    UploadPlatformImageRequest$outboundSchema.parse(uploadPlatformImageRequest),
  );
}
